import { render, staticRenderFns } from "./AppFormDialog.vue?vue&type=template&id=0b4f9822&"
import script from "./AppFormDialog.vue?vue&type=script&lang=js&"
export * from "./AppFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports